import apis from '../apis';

const title = 'Blockchain statistics';

const config = Object.freeze({
  title,
  // Legacy stats microservice support. Native v2 statistics do not use it.
  isEnabled: Boolean(apis.stats),
  // Keep the native /stats page available without enabling legacy stats calls.
  pageEnabled: true,
});

export default config;
